export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"robots","content":"noindex,nofollow"}],"link":[{"rel":"preload","href":"https://content.redesigner.jp/site-static/red-admin-front/fonts/material-symbols-outlined.561786bc18687b7e.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous","fetchpriority":"high"},{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"icon","sizes":"16x16","type":"image/png","href":"/favicon-16.png"},{"rel":"icon","sizes":"32x32","type":"image/png","href":"/favicon-32.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"}],"style":[{"children":"@font-face{font-family:'Material Symbols Outlined';font-style:normal;font-display:block;src:url(https://content.redesigner.jp/site-static/red-admin-front/fonts/material-symbols-outlined.561786bc18687b7e.woff2) format('woff2')}.material-symbols-outlined{font-family:'Material Symbols Outlined';font-weight:normal;font-style:normal;line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;white-space:nowrap;word-wrap:normal;direction:ltr;-webkit-font-smoothing:antialiased}"}],"script":[],"noscript":[],"title":"ReDesigner Admin","titleTemplate":"%s | ReDesigner Admin"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = "https://content.redesigner.jp/site-static/red-admin-front/71c453891715be9cb4e962d4e2ea56623570767b"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true